import { createSelector } from 'reselect';
import { IState } from '../createStore';
import { AUTH_STATE } from 'appRedux/types/reduxTypes';

const getAuthState = (state: IState) => state.app.persistedState?.authState;

export const selectAuthState = createSelector([getAuthState], (authState) => authState);

export const selectAuthStateTransformed = createSelector([getAuthState], (authState) => {
  return authState === AUTH_STATE.AUTHENTICATED ? true : false;
});

// Returns true once authState has been hydrated from localStorage (i.e. is
// any defined value). Used to prevent a blank screen during the brief window
// between app mount and Redux state rehydration.
export const selectAuthInitialized = createSelector([getAuthState], (authState) => {
  return authState !== undefined && authState !== null;
});
